module.exports = __webpack_public_path__ + "img/John-Hancock_Black-img-desktop.759b2d85.svg";